import InviteModal from "./invite-modal";

export default InviteModal;
